export const EmployerRepAuthTypes = {
    SSO: 'sso', // Single Sign-On (Paycor)
    PAP: 'pap', // Password Authentication Protocol
};
